export default __webpack_public_path__ + "static/269-e2d28ea4acc1285eba61a320d5bc6235.gif";